
export const judgeFocusNodeIs = (className: string) => {
    if(!window.getSelection) {
        return false;
    }
    const sel = window.getSelection();
    const focusNodeItem = sel?.focusNode;
    if (!sel || focusNodeItem == null) {
        return false;
    }
    if (
        // @ts-ignore
        !(focusNodeItem?.parentNode?.className.includes(className)
        // @ts-ignore
        || focusNodeItem?.parentNode?.parentNode?.className.includes(className))
    ) {
        return false;
    }
    return true;
}


export const insertHtmlAtCaret = (html: string, className: string) => {
    if(!judgeFocusNodeIs(className)) {
        return;
    }

    const sel = window.getSelection();

    if(!sel) {
        return;
    }
    
    if (sel.getRangeAt && sel.rangeCount) {
        let range = sel.getRangeAt(0);
        range.deleteContents();
        const el = document.createElement("div");
        el.innerHTML = html;
        const frag = document.createDocumentFragment();
        let node, lastNode;
        while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);
        if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }
}